module.exports = __webpack_public_path__ + "img/works_maum_btm_off_m.ddf6f3fc.jpg";